import React, { useEffect, useMemo, useState } from "react";

const API_BASE = process.env.REACT_APP_NAV_API || "http://localhost:8080";

const TYPES = [
  "FEATURE_LAUNCH",
  "PROCESS_UPDATE",
  "TRAINING_ANNOUNCEMENT",
  "POLICY_CHANGE",
  "CIRCULAR"
];

function todayISO() {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");  
  return `${yyyy}-${mm}-${dd}`;
}

function dateStr_(v) {
  if (!v) return "";
  return typeof v === "string" ? v : (v?.value || "");
}

function tsStr_(v) {
  if (!v) return "";
  return typeof v === "string" ? v : (v?.value || "");
}

function fmtTs_(v) {
  const s = tsStr_(v);
  if (!s) return "-";
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  return d.toLocaleString(); // nice readable
}

export default function AdminWhatsNewPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [logSummary, setLogSummary] = useState(null);
const [logRows, setLogRows] = useState([]);
const [activeTab, setActiveTab] = useState("FORM"); // FORM | POSTS | LOGS

  const [form, setForm] = useState({
    id: "",
    eventDate: todayISO(),
    type: "FEATURE",
    title: "",
    description: "",
    linkUrl: "",
    active: true,
    // createdByEmail: (localStorage.getItem("ACTIVE_DOER_EMAIL") || "").trim().toLowerCase(),
    createdByEmail: "pavankumar@geplcapital.com",
  });

  const isEdit = !!form.id;

  async function loadLogs() {
  try {
    const a = await fetch(`${API_BASE}/whatsnew/admin/logs/summary?days=30`, {
  credentials: "include",
});
    const aj = await a.json();
    setLogSummary(aj.summary || null);

const b = await fetch(`${API_BASE}/whatsnew/admin/logs/recent?limit=100`, {
  credentials: "include",
});
    const bj = await b.json();
    setLogRows(bj.rows || []);
  } catch (e) {
    setLogSummary(null);
    setLogRows([]);
  }
}
  async function load() {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/whatsnew/admin/list?limit=200`, {
  credentials: "include",
});
      const json = await res.json();
      setItems(json.items || []);
    } catch (e) {
      console.error(e);
      setItems([]);
    } finally {
      setLoading(false);
    }
  }

useEffect(() => {
  load();
  loadLogs();
}, []);

  async function submit() {
    const payload = {
      ...form,
      // backend expects eventDate, type, title, description, linkUrl, active, createdByEmail
    };

    const url = isEdit ? `${API_BASE}/whatsnew/admin/update` : `${API_BASE}/whatsnew/admin/create`;
    const res = await fetch(url, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const json = await res.json();
    if (!res.ok) {
      alert(json?.error || "Failed");
      return;
    }

    alert(isEdit ? "Updated" : "Created");
    setForm((p) => ({
      ...p,
      id: "",
      title: "",
      description: "",
      linkUrl: "",
      active: true,
    }));
    await load();
  }

  async function toggleActive(id, active) {
    const res = await fetch(`${API_BASE}/whatsnew/admin/toggleActive`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, active }),
    });
    const json = await res.json();
    if (!res.ok) {
      alert(json?.error || "Failed");
      return;
    }
    await load();
  }

  function pickForEdit(it) {
    setActiveTab("FORM");
    setForm({
      id: it.id,
      eventDate: (typeof it.event_date === "string" ? it.event_date : (it.event_date?.value || "")) || todayISO(),
      type: it.type || "FEATURE",
      title: it.title || "",
      description: it.description || "",
      linkUrl: it.link_url || "",
      active: !!it.active,
     createdByEmail:
  it.created_by_email || "pavankumar@geplcapital.com",
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ fontSize: 16, fontWeight: 900 }}>What’s New Manager</div>

        <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
  {[
    { key: "FORM", label: "Form" },
    { key: "POSTS", label: "All Posts" },
    { key: "LOGS", label: "Logs" },
  ].map((t) => {
    const isOn = activeTab === t.key;
    return (
      <button
        key={t.key}
        onClick={() => setActiveTab(t.key)}
        style={{
          padding: "8px 12px",
          borderRadius: 10,
          border: isOn ? "none" : "1px solid rgba(0,0,0,0.15)",
          background: isOn ? "#26428b" : "#fff",
          color: isOn ? "#fff" : "#111",
          fontWeight: 900,
          cursor: "pointer",
        }}
      >
        {t.label}
      </button>
    );
  })}
</div>
        {loading ? <div style={{ fontSize: 12, opacity: 0.7 }}>Loading…</div> : null}
      </div>

      {/* Form */}
      {activeTab === "FORM" && (
      <div style={{ marginTop: 12, padding: 12, borderRadius: 12, background: "rgba(0,0,0,0.03)" }}>
        <div style={{ display: "grid", gridTemplateColumns: "160px 1fr 160px", gap: 10 }}>
          <div>
            <div style={{ fontSize: 12, fontWeight: 800 }}>Date</div>
            <input
              type="date"
              value={form.eventDate}
              onChange={(e) => setForm((p) => ({ ...p, eventDate: e.target.value }))}
              style={{ width: "100%", padding: 8, borderRadius: 10, border: "1px solid rgba(0,0,0,0.15)" }}
            />
          </div>

          <div>
            <div style={{ fontSize: 12, fontWeight: 800 }}>Title</div>
            <input
              value={form.title}
              onChange={(e) => setForm((p) => ({ ...p, title: e.target.value }))}
              placeholder="Enter title"
              style={{ width: "100%", padding: 8, borderRadius: 10, border: "1px solid rgba(0,0,0,0.15)" }}
            />
          </div>

          <div>
            <div style={{ fontSize: 12, fontWeight: 800 }}>Type</div>
            <select
              value={form.type}
              onChange={(e) => setForm((p) => ({ ...p, type: e.target.value }))}
              style={{ width: "100%", padding: 8, borderRadius: 10, border: "1px solid rgba(0,0,0,0.15)" }}
            >
              {TYPES.map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </select>
          </div>

          <div style={{ gridColumn: "1 / span 3" }}>
            <div style={{ fontSize: 12, fontWeight: 800 }}>Description</div>
            <textarea
              value={form.description}
              onChange={(e) => setForm((p) => ({ ...p, description: e.target.value }))}
              placeholder="Enter description"
              rows={3}
              style={{ width: "100%", padding: 8, borderRadius: 10, border: "1px solid rgba(0,0,0,0.15)" }}
            />
          </div>

          <div style={{ gridColumn: "1 / span 2" }}>
            <div style={{ fontSize: 12, fontWeight: 800 }}>Link (optional)</div>
            <input
              value={form.linkUrl}
              onChange={(e) => setForm((p) => ({ ...p, linkUrl: e.target.value }))}
              placeholder="https://..."
              style={{ width: "100%", padding: 8, borderRadius: 10, border: "1px solid rgba(0,0,0,0.15)" }}
            />
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 18 }}>
            <input
              type="checkbox"
              checked={form.active}
              onChange={(e) => setForm((p) => ({ ...p, active: e.target.checked }))}
            />
            <div style={{ fontWeight: 800, fontSize: 13 }}>Active</div>
          </div>
        </div>

        <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
          <button
            onClick={submit}
            style={{
              padding: "8px 14px",
              borderRadius: 10,
              border: "none",
              background: "#26428b",
              color: "#fff",
              fontWeight: 900,
              cursor: "pointer",
            }}
          >
            {isEdit ? "Update" : "Create"}
          </button>

          {isEdit ? (
            <button
              onClick={() =>
                setForm((p) => ({
                  ...p,
                  id: "",
                  title: "",
                  description: "",
                  linkUrl: "",
                  active: true,
                }))
              }
              style={{
                padding: "8px 14px",
                borderRadius: 10,
                border: "1px solid rgba(0,0,0,0.2)",
                background: "#fff",
                fontWeight: 900,
                cursor: "pointer",
              }}
            >
              Cancel Edit
            </button>
          ) : null}
        </div>
      </div>
       )}

      {/* List */}
      {activeTab === "POSTS" && (
      <div style={{ marginTop: 14 }}>
        <div style={{ fontSize: 14, fontWeight: 900, marginBottom: 8 }}>All Posts</div>

        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {items.map((it) => (
            <div
              key={it.id}
              style={{
                padding: 12,
                borderRadius: 12,
                border: "1px solid rgba(0,0,0,0.08)",
                display: "flex",
                gap: 12,
                alignItems: "flex-start",
                justifyContent: "space-between",
              }}
            >
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 900 }}>
                  {it.title}{" "}
                  <span style={{ fontSize: 12, opacity: 0.7 }}>
                   ({it.type}) • {dateStr_(it.event_date)}
                  </span>
                </div>
                <div style={{ fontSize: 13, opacity: 0.85, marginTop: 4 }}>{it.description}</div>
                {it.link_url ? (
                  <div style={{ marginTop: 6, fontSize: 13 }}>
                    <a href={it.link_url} target="_blank" rel="noreferrer">
                      Open Link →
                    </a>
                  </div>
                ) : null}
                <div style={{ fontSize: 12, opacity: 0.65, marginTop: 6 }}>
                  By: {it.created_by_email} • Active: {String(!!it.active)}
                </div>
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <button
                  onClick={() => pickForEdit(it)}
                  style={{
                    padding: "8px 10px",
                    borderRadius: 10,
                    border: "1px solid rgba(0,0,0,0.2)",
                    background: "#fff",
                    fontWeight: 800,
                    cursor: "pointer",
                  }}
                >
                  Edit
                </button>
                <button
                  onClick={() => toggleActive(it.id, !it.active)}
                  style={{
                    padding: "8px 10px",
                    borderRadius: 10,
                    border: "none",
                    background: it.active ? "#ef4444" : "#22c55e",
                    color: "#fff",
                    fontWeight: 900,
                    cursor: "pointer",
                  }}
                >
                  {it.active ? "Deactivate" : "Activate"}
                </button>
              </div>
            </div>
          ))}

          {items.length === 0 ? <div style={{ opacity: 0.7 }}>No items.</div> : null}
        </div>
      </div>
        )}

     {/* Logs */}
     {activeTab === "LOGS" && (
      <div style={{ marginTop: 14 }}>
  <div style={{ fontSize: 14, fontWeight: 900, marginBottom: 8 }}>Logs (Last 30 Days)</div>

  <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 10 }}>
    <div style={{ padding: 12, borderRadius: 12, background: "rgba(38,66,139,0.08)" }}>
      <div style={{ fontSize: 12, fontWeight: 800, opacity: 0.7 }}>Total Opens</div>
      <div style={{ fontSize: 18, fontWeight: 900 }}>{logSummary?.total_opens ?? "-"}</div>
    </div>
    <div style={{ padding: 12, borderRadius: 12, background: "rgba(38,66,139,0.08)" }}>
      <div style={{ fontSize: 12, fontWeight: 800, opacity: 0.7 }}>Unique Users</div>
      <div style={{ fontSize: 18, fontWeight: 900 }}>{logSummary?.unique_users ?? "-"}</div>
    </div>
    <div style={{ padding: 12, borderRadius: 12, background: "rgba(38,66,139,0.08)" }}>
      <div style={{ fontSize: 12, fontWeight: 800, opacity: 0.7 }}>Bell Opens</div>
      <div style={{ fontSize: 18, fontWeight: 900 }}>{logSummary?.bell_opens ?? "-"}</div>
    </div>
    <div style={{ padding: 12, borderRadius: 12, background: "rgba(38,66,139,0.08)" }}>
      <div style={{ fontSize: 12, fontWeight: 800, opacity: 0.7 }}>Section Opens</div>
      <div style={{ fontSize: 18, fontWeight: 900 }}>{logSummary?.section_opens ?? "-"}</div>
    </div>
    <div style={{ padding: 12, borderRadius: 12, background: "rgba(38,66,139,0.08)" }}>
      <div style={{ fontSize: 12, fontWeight: 800, opacity: 0.7 }}>Last Opened</div>
      <div style={{ fontSize: 12, fontWeight: 900 }}>
       {fmtTs_(logSummary?.last_opened_at)}
      </div>
    </div>
  </div>

  <div style={{ marginTop: 10 }}>
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <div style={{ fontWeight: 900 }}>Recent Opens</div>
      <button
        onClick={loadLogs}
        style={{
          padding: "6px 10px",
          borderRadius: 10,
          border: "1px solid rgba(0,0,0,0.2)",
          background: "#fff",
          fontWeight: 800,
          cursor: "pointer",
        }}
      >
        Refresh Logs
      </button>
    </div>

    <div style={{ marginTop: 8, border: "1px solid rgba(0,0,0,0.08)", borderRadius: 12, overflow: "hidden" }}>
      <div style={{ display: "grid", gridTemplateColumns: "1.2fr 1fr 0.8fr 0.8fr 1fr", background: "rgba(0,0,0,0.04)", padding: 10, fontWeight: 900, fontSize: 12 }}>
        <div>Email</div>
<div>Post</div>
<div>Name</div>
<div>Source</div>
<div>Opened At</div>
      </div>

      {(logRows || []).slice(0, 50).map((r, idx) => (
        <div key={idx} style={{ display: "grid", gridTemplateColumns: "1.2fr 1fr 0.8fr 0.8fr 1fr", padding: 10, borderTop: "1px solid rgba(0,0,0,0.06)", fontSize: 12 }}>
          <div>{r.viewer_email}</div>
  <div title={r.item_title || ""}>
    {r.item_title || "-"}
  </div>
  <div>{r.viewer_name || "-"}</div>
  <div>{r.source || "-"}</div>
  <div>{fmtTs_(r.opened_at)}</div>
        </div>
      ))}

      {(!logRows || logRows.length === 0) ? (
        <div style={{ padding: 10, fontSize: 12, opacity: 0.7 }}>No logs yet.</div>
      ) : null}
    </div>
  </div>
      </div>
      )}
    </div>
  );
}